import { IState } from "@/redux/store.types";
import { getValueState } from "@/redux/utils";

import { $HasAccountModalUserDataModuleName } from "./hasAccountModalUserData.types";

const getHasAccountModalUserData = (state: IState) =>
    getValueState(state, $HasAccountModalUserDataModuleName);

export { getHasAccountModalUserData };
